"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _default = exports.default = {
  props: {
    value: {
      type: String
    },
    open: {
      type: Boolean,
      default: undefined
    },
    placeholder: {
      type: String,
      default: '选择日期时间'
    },
    defaultTime: {
      type: String,
      default: '00:00:00'
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    precision: {
      type: String,
      default: 'second',
      validator: value => ['hour', 'minute', 'second'].includes(value)
    }
  },
  data() {
    return {
      internalOpen: false,
      opened: false,
      datePickerValue: this.value
    };
  },
  computed: {
    currentValueText() {
      if (!this.datePickerValue) {
        return '';
      }
      const format = this.getFormat();
      return (0, _moment.default)(this.datePickerValue).format(format);
    },
    computedOpen() {
      return typeof this.open !== 'undefined' ? this.open : this.internalOpen;
    }
  },
  watch: {
    open(value) {
      this.handleOpenChange(value);
    }
  },
  methods: {
    handleClear() {
      this.$emit('input', undefined);
      this.datePickerValue = undefined;
    },
    getPickerContainer() {
      return this.$refs.datePickerRef.popupRef.$el.getElementsByClassName('ant-calendar')[0];
    },
    appendTimePickerToContainer() {
      setTimeout(() => {
        this.getPickerContainer().appendChild(this.$refs.timePickerRef);
      });
    },
    handleOpenChange(open) {
      this.internalOpen = open;
      this.$emit('openChange', open);
      if (this.computedOpen) {
        this.opened = true;
        this.datePickerValue = this.value;
        this.appendTimePickerToContainer();
      }
    },
    isSelected(date) {
      return (0, _moment.default)(date).format('YYYY-MM-DD') === (0, _moment.default)(this.datePickerValue).format('YYYY-MM-DD');
    },
    isSelectedTime(unit, value) {
      if (!this.datePickerValue) {
        return false;
      }
      return (0, _moment.default)(this.datePickerValue).get(unit) === value;
    },
    onDateChange(date) {
      let timeStr = this.defaultTime;
      if (this.precision === 'hour') {
        timeStr = '00:00:00';
      } else if (this.precision === 'minute') {
        timeStr = '00:00';
      }
      this.datePickerValue = (0, _moment.default)(date).format(`YYYY-MM-DD ${timeStr}`);
    },
    handleTimePick(unit, value) {
      if (!this.datePickerValue) {
        let timeStr = this.defaultTime;
        if (this.precision === 'hour') {
          timeStr = '00:00:00';
        } else if (this.precision === 'minute') {
          timeStr = '00:00';
        }
        this.datePickerValue = (0, _moment.default)().format(`YYYY-MM-DD ${timeStr}`);
      }
      let newDate = (0, _moment.default)(this.datePickerValue).set(unit, value);

      // 根据精度设置其他时间单位为0
      if (this.precision === 'hour') {
        newDate = newDate.set('minute', 0).set('second', 0);
      } else if (this.precision === 'minute') {
        newDate = newDate.set('second', 0);
      }
      this.datePickerValue = newDate.format('YYYY-MM-DD HH:mm:ss');
    },
    handleConfirm() {
      this.$emit('confirm', this.datePickerValue);
      this.$emit('input', this.datePickerValue);
      this.internalOpen = false;
      this.$emit('openChange', false);
    },
    getFormat() {
      switch (this.precision) {
        case 'hour':
          return 'YYYY-MM-DD HH';
        case 'minute':
          return 'YYYY-MM-DD HH:mm';
        case 'second':
        default:
          return 'YYYY-MM-DD HH:mm:ss';
      }
    }
  }
};